export const UNAUTHORIZED_APP_USER_DETAIL =
  "No authorized application user matches this token.";
